exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".high-light{background-color:#c2c2c2;color:red;position:relative;font-weight:700}.m-record-item{background-color:#f2f2f2;height:38px;line-height:38px;margin-bottom:8px;cursor:pointer;display:-webkit-box;display:-ms-flexbox;display:flex;text-align:center}.m-record-list{width:100%;height:100%;background-color:#d3d3d3;overflow-y:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/pdOutPatient/pdMedicalLiterature/pdfShow.vue
// module id = COb8
// module chunks = 0